// Where a Predict bug was filed, in words: the watch list's project filter,
// the dashboard's Source column and the bug page all name it the same way
// (STRY0039087's mapping, STRY0039090's shared module).

// The tracker kinds Predict's picker reads (`source` on /predict/bug). A kind
// this list doesn't know reads as its own words.
const SOURCES = { github: 'GitHub', gitlab: 'GitLab', jira: 'Jira', launchpad: 'Launchpad' };

export const sourceLabel = source => {
  if (typeof source !== 'string' || !source.trim()) return '—';
  const key = source.trim().toLowerCase();
  if (SOURCES[key]) return SOURCES[key];
  const words = source.trim().replace(/[_-]/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
};

// Where a list bug was filed, from its link, for a list row without `source`
// (an ODD stage without STRY0039096): the host stands in for it. 'github' | 'gitlab' |
// 'launchpad' | 'jira', or null for a host this doesn't know or a link that
// isn't http(s).
export const sourceFromUrl = url => {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
  const host = parsed.hostname.toLowerCase();
  // A domain matches itself or a subdomain, never a host that merely ends in it.
  const on = domain => host === domain || host.endsWith(`.${domain}`);
  if (on('github.com')) return 'github';
  if (on('gitlab.com') || host.startsWith('gitlab.')) return 'gitlab';
  if (on('launchpad.net')) return 'launchpad';
  if (on('atlassian.net') || host.startsWith('jira.') || parsed.pathname.startsWith('/browse/')) return 'jira';
  return null;
};

// Where a bug was filed: its own `source` (on list rows since STRY0039096 and
// on the bug detail), lower-cased so one kind counts once, else its link's
// host (`sourceFromUrl`). Null when neither says.
export const bugSource = bug => {
  if (typeof bug?.source === 'string' && bug.source.trim()) return bug.source.trim().toLowerCase();
  return sourceFromUrl(bug?.url);
};
